import getAlreadyRendered from './getalreadyrendered.js';
import renderItemNode from './renderitemnode.js';
import triggerOne from '../../trigger/_triggerone.js';
// this function re-inserts rendered DOM nodes of items
// if they are rendered and forceRerender is falsy
// and renders array items from scratch if they aren't rendered yet or forceRerender is truthy
export default function processRerender(_ref) {
  var self = _ref.self,
    selfDef = _ref.selfDef,
    eventOptions = _ref.eventOptions,
    container = _ref.container;
  var forceRerender = eventOptions.forceRerender,
    silent = eventOptions.silent;
  // iterate over all items
  for (var i = 0; i < self.length; i++) {
    var item = self[i];
    if (item && typeof item === 'object') {
      var _selfDef$containers;
      var alreadyRenderedNode = getAlreadyRendered({
        item: item,
        selfDef: selfDef
      });
      // if item is already rendered and forceRerender is falsy then re-insert DOM node
      // go to the next cycle iteration then
      if (!forceRerender && alreadyRenderedNode) {
        container.appendChild(alreadyRenderedNode);
        continue;
      }
      // a forced rerender removes the old node, also from a container the array no longer uses
      var parent = alreadyRenderedNode == null ? void 0 : alreadyRenderedNode.parentNode;
      if (parent && (_selfDef$containers = selfDef.containers) != null && _selfDef$containers.has(parent)) {
        parent.removeChild(alreadyRenderedNode);
      }
      // render new node
      var _renderItemNode = renderItemNode({
          selfDef: selfDef,
          self: self,
          item: item,
          eventOptions: eventOptions
        }),
        node = _renderItemNode.node,
        itemEventOptions = _renderItemNode.itemEventOptions;
      if (node) {
        container.appendChild(node);
        if (!silent) {
          triggerOne(item, 'afterrender', itemEventOptions);
        }
      }
    }
  }
}